<template>
  <div class="background" :class="{'background_landing-page-version': landingPageVersion}">
    <div v-if="!pageIsLoaded" class="spinner-container">
      <spinner-el class="spinner" />
    </div>

    <template v-else>
      <market-overview v-if="!landingPageVersion" />
      <div class="currencies-table" :class="{'currencies-table_landing-page-version': landingPageVersion}">
        <div class="currencies-table__header" v-if="!landingPageVersion">
          <currencies-table-filter
            v-model="searchKeyword"
            class="currencies-table__filter"
            @input="throttledSearch"
            :foundTickersCount="foundTickersCount"
            :placeholder="filterPlaceholder"
            :inProgress="tableUpdatingInProgress"
          />
          <div class="currencies-table__switches" v-if="showTabs">
            <div class="switches-buttons">
              <button title="All Currenices" type="button" class="currencies-table__switch currencies-table__switch_all" :class="{'currencies-table__switch_active': allCurrencyTabSelected}"  @click="selectAllCurrencyTab">
                <icon-all-rows class="icon-all-rows icon" />
              </button>
              <add-favorite-btn title="Favourites" class="currencies-table__switch" :class="{'currencies-table__switch_active': favouriteTabSelected}" :disabled="userFavoriteTickersListIsEmpty" @click="selectFavouritesTab" />
              <div class="switches-buttons__circle" :class="{'switches-buttons__circle_all': allCurrencyTabSelected, 'switches-buttons__circle_favourites': favouriteTabSelected}"></div>
            </div>
          </div>
        </div>

        <div class="top-currencies" v-if="landingPageVersion">
          <div class="top-currencies__title">
            TOP 10 cryptocurrencies
          </div>
        </div>

        <div class="table-wrapper">
          <table-el
            red
            v-if="foundTickersCount"
            :animated="enableRowsAnimations"
            :showTableSpinner="tableUpdatingInProgress"
            :class="{'table__currencies_blur': tableUpdatingInProgress, 'table__currencies_loadMore-request': loadingMore}"
            class="table__currencies"
          >
            <tr slot="thead" class="table__trh" :class="{ tableUpdatingInProgress }" id="sortPanel" ref="sortPanel">
              <th @click="setOrderBy(sortingFields.name)" :class="{'table__th_currency_long': !loginInfo}" class="table__th_sortable table__th table__th_currency">
                currency
                <sorting-arrow v-if="sortField === sortingFields.name" :sortOrder="sortOrder" />
              </th>
              <th @click="setOrderBy(sortingFields.ticker)" class="table__th table__th_sortable table__th_ticker">
                ticker
                <sorting-arrow v-if="sortField === sortingFields.ticker" :sortOrder="sortOrder" />
              </th>
              <th @click="setOrderBy(sortingFields.priceUsd)" class="table__th table__th_sortable table__th_price">
                price
                <sorting-arrow v-if="sortField === sortingFields.priceUsd" :sortOrder="sortOrder" />
              </th>
              <th class="table__th table__th_not-sortable table__th_graph">graph, 7d</th>
              <th @click="setOrderBy(sortingFields.percentChange24h)" class="table__th table__th_sortable table__th_percent-change">
                daily cng
                <sorting-arrow v-if="sortField === sortingFields.percentChange24h" :sortOrder="sortOrder" />
              </th>
              <th @click="setOrderBy(sortingFields.marketCapUsd)" class="table__th table__th_sortable table__th_marketcap">
                market cap
                <sorting-arrow v-if="sortField === sortingFields.marketCapUsd" :sortOrder="sortOrder" />
              </th>
              <th @click="setOrderBy(sortingFields.marketVol24h)" class="table__th table__th_sortable table__th_volume">
                volume, 24h
                <sorting-arrow v-if="sortField === sortingFields.marketVol24h" :sortOrder="sortOrder" />
              </th>
              <!-- <th class="table__th table__th_alert"></th> -->
              <th class="table__th table__th_add-favourite" v-if="loginInfo"></th>
            </tr>

            <tr slot="tbody" v-for="ticker in tickersTableList" :key="ticker.id" class="table__tr">
              <td class="table__td table__td_currency">
                <div class="td-flex-wrapper">
                  <router-link :to="`/currency/${ticker.id}`" class="ticker-name-link">
                    <div class="icon-wrapper">
                      <currency-icon :currencyId="ticker.id" class="icon"/>
                    </div>
                      <span class="ticker-name" :title="ticker.name"> {{ticker.name}}</span>
                  </router-link>
                </div>
              </td>
              <td class="table__td table__td_ticker">
                <div class="hover-links" :class="{ 'hover-links_logged-in': loginInfo }">
                  <router-link :to="`/currency/${ticker.id}`" class="hover-links__link hover-links__link_currency-page">CURRENCY PAGE</router-link>
                  <router-link :to="`/add-alert/${ticker.id}`" class="hover-links__link hover-links__link_set-alert">
                    <span class="hl__text hl__text_full">SET ALERT</span>
                    <span class="hl__text hl__text_short">ALERT</span>
                  </router-link>
                </div>
                <span class="not-hover-text">
                  {{ticker.symbol}}
                </span>
              </td>
              <td class="table__td table__td_price">{{ticker | getObjPropInSelectedCurrency('price', currencyCode) | formatMoney(currencyCode)}}</td>
              <td class="table__td table__td_graph">
                <graph-el :tickerId="ticker.id" />
              </td>
              <td class="table__td table__td_percent-change">
                <percent-trend :value="ticker | getObjPropInSelectedCurrency('percentChange24h', currencyCode)"/>
              </td>
              <td class="table__td table__td_marketcap">{{ticker | getObjPropInSelectedCurrency('marketCap', currencyCode) | formatMoney(currencyCode)}}</td>
              <td class="table__td table__td_volume">{{ticker | getObjPropInSelectedCurrency('marketVol24h', currencyCode) | formatMoney(currencyCode)}}</td>
              <td class="table__td table__td_add-favourite" v-if="loginInfo">
                <add-favorite-btn
                  class="add-favorite-btn"
                  :disabled="requestInProgress"
                  :fill="starFillStatus(ticker.isFavourite)"
                  @click="onClickFavouriteBtn(ticker, ticker.isFavourite)"
                />
              </td>
              <div class="hover">
                <add-favorite-btn
                  v-if="loginInfo"
                  class="add-favorite-btn add-favorite-btn_mobile"
                  :disabled="requestInProgress"
                  :fill="starFillStatus(ticker.isFavourite)"
                  @click="onClickFavouriteBtn(ticker, ticker.isFavourite)"
                />
                <div class="hover__invis-block"></div>
              </div>
            </tr>
          </table-el>
        </div>
        <spinner-el class="spinner_load-more" v-if="loadingMore"/>
        <div ref="loadMoreBtnAnchor"></div>
        <load-more-btn
          :disabled="loadingMore || tableUpdatingInProgress"
          class="load-more"
          @click="loadMore"
          v-if="showLoadingMoreBtn"
          :count="loadMoreCount"
        ></load-more-btn>
      </div>
    </template>
  </div>
</template>

<script>
  import { mapActions, mapState, mapGetters } from 'vuex';
  import sortingArrow from 'Uikit/SortingArrow';
  import { tickersUpdateMinInterval, apiUrl, limitTickersHomePage, maxCountLoadingMoreBtn as limitTickers, currenciesTabLocalStorageName } from 'src/utils/config';
  import { formatMoney, getAvailableCountForLoadingMore, getObjPropInSelectedCurrency, checkCurrentDeviceIsMobile } from 'src/utils/helpers';
  import currenciesTableTabs from 'src/models/CurrenciesTableTabs';
  import currenciesTableFilter from 'src/components/CurrenciesTableFilter';
  import sortingFields from 'src/models/CurrenciesSortingFields'; // eslint-disable-line no-named-as-default
  import throttle from 'lodash/throttle';
  import { IconAllRows } from 'Icons';
  import marketOverview from './MarketOverview';

  export default {
    components: {
      sortingArrow,
      marketOverview,
      IconAllRows,
      currenciesTableFilter,
    },
    props: {
      landingPageVersion: Boolean,
    },
    data: () => ({
      loadingMore: false,
      currenciesTableTabs,
      requestInProgress: false,
      timerId: null,
      sortField: null,
      sortOrder: 'asc',
      tableUpdatingInProgress: false,
      pageIsLoaded: false,
      searchKeyword: '',
    }),
    name: 'currenciesTable',
    computed: {
      getAvailableCountForLoadingMore,
      ...mapState('tickers', [
        'tickersList',
        'userFavoriteTickersList',
        'totalRowsCount',
        'foundRowsCount',
        'totalRowsCountFavortiteTickers',
        'foundRowsCountFavortiteTickers',
      ]),
      ...mapState('userData', ['loginInfo']),
      ...mapGetters('tickers', ['searchControlPlaceholder', 'searchControlFavouritesPlaceholder']),
      ...mapGetters('userData', ['currencyCode']),
      apiUrl: () => apiUrl,
      sortingFields: () => sortingFields,
      enableRowsAnimations() {
        return this.favouriteTabSelected && !this.tableUpdatingInProgress;
      },
      foundTickersCount() {
        return this.favouriteTabSelected ? this.foundRowsCountFavortiteTickers : this.foundRowsCount;
      },
      tickersTableList() {
        if (this.landingPageVersion || this.allCurrencyTabSelected) {
          return this.tickersList;
        }
        return this.userFavoriteTickersList;
      },
      filterPlaceholder() {
        return this.favouriteTabSelected ? this.searchControlFavouritesPlaceholder
          : this.searchControlPlaceholder;
      },
      thereAreUnloadedRows() {
        const allRowsResultsCount = this.searchKeyword ? this.foundRowsCount : this.totalRowsCount;
        const favouritesResultsCount = this.searchKeyword ? this.foundRowsCountFavortiteTickers
          : this.totalRowsCountFavortiteTickers;
        return (this.allCurrencyTabSelected && (allRowsResultsCount > this.tickersList.length)) ||
          (this.favouriteTabSelected && (favouritesResultsCount > this.userFavoriteTickersList.length));// eslint-disable-line max-len
      },
      allCurrencyTabSelected() {
        return this.$route.meta.allCurrencyTabSelected;
      },
      favouriteTabSelected() {
        return this.$route.meta.favouritesTabSelected;
      },
      userFavoriteTickersListIsEmpty() {
        return !this.totalRowsCountFavortiteTickers;
      },
      tickerUpdateMethod() {
        if (this.favouriteTabSelected) {
          return this.updateUserFavoriteTickers;
        }
        if (this.allCurrencyTabSelected) {
          return this.updateTickers;
        }
        return null;
      },
      currenciesRequestParams() {
        const params = {
          kw: this.searchKeyword,
        };
        if (this.landingPageVersion) {
          params.limit = limitTickersHomePage;
        }
        if (this.sortField) {
          params.sort_field = this.sortField;
          params.sort_order = this.sortOrder;
        }
        return params;
      },
      loadMoreCount() {
        if (this.favouriteTabSelected) {
          return getAvailableCountForLoadingMore(this.totalRowsCountFavortiteTickers, this.userFavoriteTickersList.length); // eslint-disable-line max-len
        }
        if (this.landingPageVersion) {
          return 100;
        }
        return getAvailableCountForLoadingMore(this.totalRowsCount, this.tickersList.length);
      },
      showTabs() {
        return !!this.loginInfo;
      },
      showLoadingMoreBtn() {
        return (this.foundTickersCount && this.thereAreUnloadedRows) || this.landingPageVersion;
      },
      currenciesTabFromLocalStorage() {
        return localStorage.getItem(currenciesTabLocalStorageName);
      },
      savedСurrenciesTabIsAllCurrencies() {
        return this.currenciesTabFromLocalStorage === currenciesTableTabs.all;
      },
      savedСurrenciesTabIsFavourites() {
        return this.currenciesTabFromLocalStorage === currenciesTableTabs.favourites;
      },
    },
    filters: {
      formatMoney,
      getObjPropInSelectedCurrency,
    },
    methods: {
      ...mapActions('tickers', [
        'updateTickers',
        'loadMoreTickers',
        'updateUserFavoriteTickers',
        'addToFavoriteUserTickers',
        'removeFromFavoriteUserTickers',
        'loadMoreUserFavoriteTickers',
        'updateNumberNewCurrencies',
      ]),
      throttledSearch() {},
      selectActiveTab() {
        if (this.loginInfo) {
          this.updateUserFavoriteTickers(this.currenciesRequestParams)
          .catch((data) => {
            if (data.tokenExpired) {
              return Promise.resolve([]);
            }
            return Promise.reject(data);
          })
          .then(() => {
            if (this.allCurrencyTabSelected || !this.userFavoriteTickersList.length) {
              this.selectAllCurrencyTab().then(() => {
                this.pageIsLoaded = true;
              });
            } else if (this.favouriteTabSelected) {
              Promise.all([
                this.updateTickers(this.currenciesRequestParams),
                this.selectFavouritesTab(false),
              ]).then(() => {
                this.pageIsLoaded = true;
              });
            } else if (this.savedСurrenciesTabIsAllCurrencies) {
              this.selectAllCurrencyTab().then(() => {
                this.pageIsLoaded = true;
              });
            } else {
              Promise.all([
                this.updateTickers(this.currenciesRequestParams),
                this.selectFavouritesTab(false),
              ]).then(() => {
                this.pageIsLoaded = true;
              });
            }
          });
        } else if (this.landingPageVersion) {
          this.updateTickers(this.currenciesRequestParams).then(() => {
            this.pageIsLoaded = true;
          });
        } else {
          this.selectAllCurrencyTab().then(() => {
            this.pageIsLoaded = true;
          });
        }
      },
      setOrderBy(field) {
        if (checkCurrentDeviceIsMobile()) {
          this.scrollToSortPanel(field);
        }
        if (this.landingPageVersion || this.tableUpdatingInProgress) {
          return;
        }
        if (this.sortField === field) {
          this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
        } else {
          this.sortField = field;
          this.sortOrder = 'asc';
        }
        this.searchTickers();
      },
      searchTickers(resetLimit = false) {
        this.tableUpdatingInProgress = true;
        if (resetLimit) {
          this.currenciesRequestParams.limit = this.landingPageVersion ? limitTickersHomePage
            : limitTickers;
        }
        this.tickerUpdateMethod(this.currenciesRequestParams).then(() => {
          this.tableUpdatingInProgress = false;
        });
      },
      autoUpdateTickers() {
        this.timerId = setTimeout(() => {
          if (!this.tickerUpdateMethod) {
            this.autoUpdateTickers();
            return;
          }
          this.tickerUpdateMethod(this.currenciesRequestParams).finally(() => {
            this.autoUpdateTickers();
          });
        }, tickersUpdateMinInterval);
      },
      starFillStatus(isFavourite) {
        if (this.favouriteTabSelected) {
          return true;
        }
        return isFavourite;
      },
      selectAllCurrencyTab() {
        this.searchKeyword = null;
        const tickerUpdatePromise = this.updateTickers(this.currenciesRequestParams);
        this.$router.replace('/all-currencies/all');
        localStorage.setItem(currenciesTabLocalStorageName, currenciesTableTabs.all);
        return tickerUpdatePromise;
      },
      selectFavouritesTab(needToUpdateFavourites = true) {
        this.searchKeyword = null;
        let tickerUpdatePromise;
        if (needToUpdateFavourites) {
          tickerUpdatePromise = this.updateUserFavoriteTickers(this.currenciesRequestParams);
        } else {
          tickerUpdatePromise = Promise.resolve();
        }
        this.$router.replace('/all-currencies/favourites');
        localStorage.setItem(currenciesTabLocalStorageName, currenciesTableTabs.favourites);
        return tickerUpdatePromise;
      },
      removeFromFavorite(currency) {
        this.requestInProgress = true;
        this.removeFromFavoriteUserTickers(currency).then(() => {
          this.updateTickers(this.currenciesRequestParams);
          this.updateUserFavoriteTickers(this.currenciesRequestParams);
          this.requestInProgress = false;
        }).catch(() => {
          this.requestInProgress = false;
        });
      },
      addToFavoriteUserTickersWrapper(currency) {
        this.requestInProgress = true;
        this.addToFavoriteUserTickers(currency).then(() => {
          this.updateUserFavoriteTickers(this.currenciesRequestParams);
          this.requestInProgress = false;
        }).catch(() => {
          this.requestInProgress = false;
        });
      },
      onClickFavouriteBtn(currency, favourite) {
        if ((favourite && this.allCurrencyTabSelected) || this.favouriteTabSelected) {
          this.removeFromFavorite(currency);
        } else {
          this.addToFavoriteUserTickersWrapper(currency);
        }
      },
      loadMore() {
        if (this.landingPageVersion) {
          this.$router.push('/all-currencies/all');
          return;
        }
        this.scrollToLoadMoreBtn();
        this.loadingMore = true;
        const endpoint = this.allCurrencyTabSelected ?
          this.loadMoreTickers : this.loadMoreUserFavoriteTickers;
        endpoint(this.currenciesRequestParams).then(() => {
          this.loadingMore = false;
        }).catch(() => {
          this.loadingMore = false;
        });
      },
      cancelAutoUpdate() {
        clearTimeout(this.timerId);
      },
      scrollToSortPanel() {
        this.$refs.sortPanel.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      },
      scrollToLoadMoreBtn() {
        this.$refs.loadMoreBtnAnchor.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      },
    },
    beforeDestroy() {
      this.cancelAutoUpdate();
    },
    created() {
      this.throttledSearch = throttle(() => {
        this.searchTickers(true);
      }, 600);
      this.cancelAutoUpdate();
      this.autoUpdateTickers();
      this.selectActiveTab();
      this.updateNumberNewCurrencies();
    },
    watch: {
      userFavoriteTickersListIsEmpty(empty) {
        if (empty && this.favouriteTabSelected) {
          this.selectAllCurrencyTab();
        }
      },
      loginInfo(newVal, oldVal) {
        const userStillLoggedInOrNot = newVal && oldVal;
        if (userStillLoggedInOrNot) {
          return;
        }
        const userLoggedIn = !!newVal;
        if (userLoggedIn) {
          this.updateUserFavoriteTickers(this.currenciesRequestParams);
        } else {
          this.selectAllCurrencyTab();
        }
      },
    },
  };
</script>

<style scoped lang="scss">
  .cc {
    font-size: 30px;
  }
  .spinner {
    margin: auto;
  }
  .icon {
    width: 16px;
  }
  .icon-wrapper {
    display: inline-block;
    position: relative;
    top: 1px;
    width: 28px;
    height: 16px;
  }
  .load-more-btn {
    display: block;
    margin: 33px auto;
    width: 722px;
  }
  .load-more {
    width: 100%;
    padding: 16px 30px!important;
    display: block;
    text-align: center !important;
  }
  .background {
    @include background(0px);
    &_landing-page-version {
      height: 740px;
    }
  }
  .currencies-table {
    @include container;
    max-width: 964px;
    background: $white-color2;
    margin-top: 30px;
    border-radius: 5px;
    &__filter {
      flex: 1;
    }
    &__header {
      display: flex;
    }
    &_landing-page-version {
      top: -111px;
      position: relative;
      .table__td_currency {
        padding-left: 31px;
      }
    }
    &__switches {
      padding: 20px 25px;
    }
    &__switch {
      @include removeBtnDefaults;
      width: 29px !important;
      height: 29px;
      display: inline-flex;
      border-radius: 100%;
      position: relative;
      &>.icon {
        margin: auto;
      }
      &:first-child {
        margin-right: 15px;
      }
      &[disabled] {
        cursor: not-allowed;
      }
      &:hover {
        background: $red-color18;
      }
    }
    &__switch_active {
      &:hover {
        background: transparent;
        cursor: default;
      }
    }
  }
  $row-border-bottom: 1px solid $grey-color3;
  $row-height: 63px;
  .table {
    &__tr {
      border-bottom: $row-border-bottom;
      &:last-child {
        border-bottom: none;
      }
      .hover {
        left: 0;
        height: $row-height;
        display: flex;
        align-items: center;
        width: 100%;
        position: absolute;
        opacity: 0;
      }
      .hover-links {
        display: none;
      }
      &:hover {
        .table__td_ticker {
          position: static;
        }
        .table__td_currency,
        .table__td_ticker,
        .table__td_add-favourite {
          z-index: 2;
        }
        .ticker-name-link {
          color: $white-color2;
        }
        .not-hover-text {
          display: none;
        }
        .hover-links {
          display: inline-flex;
          position: absolute;
          z-index: 3;
          margin-top: -32px;
          &__link {
            z-index: 2;
            @include font(12px, $white-color2, 600);
            text-transform: uppercase;
            text-decoration: none;
            height: $row-height;
            display: flex;
            align-items: center;
            &:not(:first-child) {
              margin-left: 33px;
            }
          }
        }
        .hover {
          z-index: 1;
          background: $red-color3;
          opacity: 1;
          user-select: inherit;
        }
      }
    }
    &__th {
      &_sortable {
        cursor: pointer;
        user-select: none;
      }
      &_not-sortable {
        color: $black-color1 !important;
      }
      padding: 12px 0 12px 31px;
      &_add-favourite {
        padding-left: 0;
        padding-right: 0;
      }
    }
    .tableUpdatingInProgress {
      .table__th_sortable {
        cursor: not-allowed;
      }
    }
    &__td {
      height: $row-height;
      padding: 21px 32px;
      @include font(12px, $black-color1, 500);
      &_add-favourite {
        padding-left: 0;
        padding-right: 0;
        button {
          width: 77px;
        }
      }
    }
    .td-flex-wrapper {
      display: flex;
      align-items: center;
      padding-right: 0;
    }

    &__td,
    &__th {
      table-layout:fixed;
      overflow:hidden;
      word-wrap:break-word;
      text-overflow: ellipsis;
      padding-right: 0;
      position: relative;
      &_currency {
        width: 198px;
        padding-right: 32px;
        &_long {
          width: 207px;
        }
      }
      &_ticker{
        width: 114px;
      }
      &_marketcap {
        width: 174px;
        padding-left: 13px;
      }
      &_price {
        width: 147px;
        padding-left: 1px;
      }
      &_volume {
        width: 179px;
        padding-left: 0px;
      }
      &_add-favourite {
        width: 50px;
        padding: 19px 0;
      }
      &_graph {
        width: 66px;
        min-width: 66px;
        padding-left: 0;
      }
      &_ticker {
        padding-left: 0;
      }
      &_percent-change {
        width: 134px;
      }
      &_alert {
        width: 43px;
        padding-left: 0;
        text-align: center;
        &:last-child {
          padding-right: 27px;
        }
      }
    }
    &__currencies {
      width: 100%;
      text-align: left;
      &_blur {
        &:after {
          content: '';
          width: 100%;
          height: calc(100% - 40px);
          background: $white-color2;
          opacity: 0.7;
          position: absolute;
          z-index: 2;
          left: 0;
          top: 40px;
          border-radius: 0 0 5px 5px;
        }
      }
      &_loadMore-request {
        .table__tr:last-child {
          border-bottom: 1px solid $grey-color3;
        }
      }
    }
  }

  .table {
    &:last-child {
      border-bottom: 1px solid $grey-color3;
    }
  }
  .alert-btn {
    @include font(12px, $red-color3, 600);
    text-decoration: none;
    user-select: none;
    &:visited,
    &:hover,
    &:active {
      color: $red-color3;
    }
  }
  .chart {
    width: 64px;
  }
  .switches-buttons {
    position: relative;
    display: flex;
    &__circle {
      width: 3px !important;
      height: 3px !important;
      top: -5px !important;
    }
    &__circle_all {
      @include activeCircle(12px);
    }
    &__circle_favourites {
      @include activeCircle(58px);
    }
  }

  .top-currencies {
    &__title {
      padding: 26px 0;
      text-align: center;
      width: 100%;
      @include font(16px, $red-color3, bold);
      text-transform: uppercase;
      display: inline-block;
      letter-spacing: 0.1px;
    }
    &__btn {
      float: right;
      @include clearfix;
      margin-right: 59px;
      margin-top: 29px;
      padding: 9px 20px;
      max-width: 122px;
    }
  }
  .spinner_load-more {
    position: static;
    will-change: margin-top, margin-bottom;
    $margin: 57px;
    margin-bottom: $margin;
    margin-top: $margin;
  }
  .icon-all-rows {
    position: absolute;
    top: 9px;
    left: 6px;
  }
  .ticker-name {
    display: inline-block;
    @include trimOverflowText(80px);
  }
  .ticker-name-link {
    text-decoration: none;
    color: $black-color1;
  }

  .add-favorite-btn_mobile {
    display: none;
  }
  .hl__text {
    &_short {
      display: none;
    }
  }

  @keyframes preventUnexpectedClick {
    from {
      z-index: -10;
    }
    to {
      z-index: 5;
    }
  }
  $header-row-height: 41px;
  /* Large Devices, Wide Screens */
  @media only screen and (max-width : 1440px) {

  }

  /* Medium Devices, Desktops */
  @media only screen and (max-width : 1280px) {

  }

  @media only screen and (max-width : 1095px) {
    .currencies-table {
      width: calc(100% - 20px);
      &_landing-page-version {
        top: auto;
        .load-more {
          z-index: 1;
          position: relative;
          background: $white-color2;
        }
      }
    }
  }

  /* Small Devices, Tablets */
  @media only screen and (max-width : 1024px) {
    .hover {
      pointer-events: none;
      &__invis-block {
        width: 100%;
        height: 100%;
        z-index: 4;
        pointer-events: none !important;
        transition: width 0s .3s, height 0s .3s;
      }
    }
    .table__tr:hover {
      .hover {
        &__link {
          &_currency-page {
            left: 19%;
          }
          &_set-alert {
            left: 30%;
          }
        }
        &__invis-block {
          width: 0;
          height: 0;
          pointer-events: auto !important;
        }
      }
      .add-favorite-btn_mobile {
        pointer-events: auto !important;
      }
      .hover-links,
      .table__td_currency,
      .add-favorite-btn_mobile {
        animation-duration: .3s;
        animation-name: preventUnexpectedClick;
        animation-fill-mode: forwards;
      }
    }
    .table__trh,
    .table__tr {
      &:before,
      &:after {
        content: '';
        position: absolute;
        width: 20px;
        background-color: $white-color2;
        filter: blur(4px);
      }
      &:after {
        right: -6px;
      }
      &:before {
        z-index: 1;
        margin-left: -11px;
      }
    }
    .table__tr {
      &:after,
      &:before {
        height: $row-height - 7;
        margin-top: 3px;
      }
    }
    .table__trh {
      &:after,
      &:before {
        background-color: $red-color21;
        height: $header-row-height - 8;
        margin-top: 3px;
      }
    }
    .table__td_add-favourite {
      display: none;
    }
    .add-favorite-btn {
      display: none;
      &_mobile {
        display: block;
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 81px !important;
        height: 100%;
      }
    }
    .table__currencies {
      min-width: 800px;
    }
    .table__td,
    .table__th, {
      &_ticker {
        padding-left: 15px;
      }
    }
    .currencies-table_landing-page-version {
      overflow: hidden;
    }
  }

  @media only screen and (max-width: 987px) {
    $first-column-width: 198px;
    .table-wrapper {
      overflow-x: auto;
    }
    .currencies-table {
      position: relative;
      overflow-x: hidden;
    }
    .table__currencies {
      margin-left: $first-column-width;
      position: static !important;
    }
    .table__th_currency {
      background: $red-color20;
      height: $header-row-height;
    }
    .table__td_currency {
      border-bottom: $row-border-bottom;
      background: $white-color2;
    }
    .table__tr {
      &:hover {
        .table__td_currency {
          background: $red-color18;
          border-bottom-color: $red-color18;
        }
      }
      &:first-of-type {
        .table__td_currency {
          margin-top: 1px !important;
        }
      }
    }
    .table__td_currency, .table__th_currency {
      width: $first-column-width;
      position: absolute;
      left: 0;
      z-index: 2;
    }
  }

  /* Extra Small Devices, Phones */
  @media only screen and (max-width : 768px) {

  }

  @media only screen and (max-width : 570px) {
    $row-height: 60px;
    .table__td {
      padding: 20px 0 20px 32px;
      height: $row-height;
      max-height: $row-height;
      &_price {
        padding-left: 1px;
      }
      &_graph {
        padding-left: 0px;
      }
      &_marketcap {
        padding-left: 13px;
      }
      &_volume {
        padding-left: 0px;
      }
      &_ticker {
        padding-left: 15px;
      }
    }
    .hover {
      &#{&}#{&} {
        height: $row-height;
      }
    }
    .hover-links__link_currency-page {
      &#{&}#{&} { // increase specificity
        display: none;
      }
    }
    .hover-links__link:not(:first-child) {
      &#{&}#{&} { // increase specificity
        margin-left: 0;
      }
    }
    .currencies-table {
      overflow: hidden;
    }
    .hl__text {
      &_full {
        display: none;
      }
      &_short {
        display: block;
      }
    }
  }
  @media only screen and (max-width : 400px) {
    .currencies-table {
      margin-top: 10px;
    }
  }

  /* Custom, iPhone Retina */
  @media only screen and (max-width : 350px) {
    .hover-links_logged-in {
      left: 170px;
    }
  }

  @media only screen and (max-width : 320px) {
    .currencies-table_landing-page-version {
      margin-top: 57px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/currenciesTable/index.vue